import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const TimelineDesignSettings = {
  // width
  'timeline-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  // alignment
  'timeline-design-comp-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // text lines
  'timeline-design-title-lines': {
    phone: [2],
    'phone-landscape': [2],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [2],
    tv: [2],
  },
  'timeline-design-content-lines': {
    phone: [2],
    'phone-landscape': [2],
    tablet: [2],
    'tablet-landscape': [2],
    desktop: [2],
    tv: [2],
  },
  // orientation
  'timeline-design-orientation': {
    phone: 'vertical',
    'phone-landscape': 'vertical',
    tablet: 'vertical',
    'tablet-landscape': 'vertical',
    desktop: 'vertical',
    tv: 'vertical',
  },
  // typography
  'timeline-design-typography': {
    'timeline-design-group-title-typography': {
      phone: getDefaultTypography('Headline Extra Small'),
      'phone-landscape': getDefaultTypography('Headline Extra Small'),
      tablet: getDefaultTypography('Headline Extra Small'),
      'tablet-landscape': getDefaultTypography('Headline Extra Small'),
      desktop: getDefaultTypography('Headline Extra Small'),
      tv: getDefaultTypography('Headline Extra Small'),
    },
    'timeline-design-title-typography': {
      phone: getDefaultTypography('Title Small'),
      'phone-landscape': getDefaultTypography('Title Small'),
      tablet: getDefaultTypography('Title Small'),
      'tablet-landscape': getDefaultTypography('Title Small'),
      desktop: getDefaultTypography('Title Small'),
      tv: getDefaultTypography('Title Small'),
    },
    'timeline-design-content-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'timeline-design-date-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
  // spacing
  'timeline-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'timeline-design-item-gap': {
    phone: {
      value: 24,
      unit: 'px',
    },
    'phone-landscape': {
      value: 24,
      unit: 'px',
    },
    tablet: {
      value: 24,
      unit: 'px',
    },
    'tablet-landscape': {
      value: 24,
      unit: 'px',
    },
    desktop: {
      value: 24,
      unit: 'px',
    },
    tv: {
      value: 24,
      unit: 'px',
    },
  },
  'timeline-data-set-limit': {
    phone: 10,
    'phone-landscape': 10,
    tablet: 10,
    'tablet-landscape': 10,
    desktop: 10,
    tv: 10,
  },
  // color
  'timeline-design-title-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'timeline-design-title-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'timeline-design-title-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'timeline-design-title-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'timeline-design-title-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'timeline-design-content-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'timeline-design-content-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'timeline-design-content-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'timeline-design-content-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'timeline-design-content-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'timeline-design-date-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'timeline-design-date-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'timeline-design-date-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'timeline-design-date-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'timeline-design-date-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'timeline-design-group-title-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'timeline-design-group-title-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'timeline-design-group-title-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'timeline-design-group-title-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'timeline-design-group-title-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
}
